import { memo } from 'react'
import { AuthByUsername } from '../../../../features/AuthByUsername'
import { StickyHeader } from '../../../../shared/ui/StickyHeader'
import { classNames } from '../../../../shared/lib/classNames/classNames'
import cls from './LoginPage.module.scss'

interface LoginPageProps {
    className?: string
}

const LoginPage = memo((props: LoginPageProps) => {
    const { className } = props

    return (
        <div className={classNames(cls.LoginPage, {}, [className])}>
            <StickyHeader
                onPrimaryCtaClick={() => {
                    window.location.href = '/'
                }}
            />
            <AuthByUsername />
        </div>
    )
})

export default LoginPage
